export default __webpack_public_path__ + "static/media/festrahmen.9cbe33fc.jpg";